import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const SIZE_MAP = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xl',
};

const DIALOG_CLASS = {
  xxl: 'hr-form-modal-xxl',
};

function FormModal({
  show,
  title,
  onHide,
  onSave,
  saveLabel = 'Save',
  saveDisabled = false,
  children,
  formId,
  size = 'lg',
  className = '',
}) {
  const handleSave = () => {
    if (onSave) {
      onSave();
      return;
    }
    if (formId) {
      const form = document.getElementById(formId);
      if (form) form.requestSubmit();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size={SIZE_MAP[size] || 'lg'}
      dialogClassName={DIALOG_CLASS[size] || ''}
      centered
      backdrop="static"
      scrollable
      className={`hr-form-modal ${className}`}
    >
      <Modal.Header closeButton className="hr-form-modal-header">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="hr-form-modal-body">{children}</Modal.Body>
      <Modal.Footer className="hr-form-modal-footer">
        <Button variant="secondary" className="hr-btn-secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" className="hr-btn-primary" onClick={handleSave} disabled={saveDisabled}>
          {saveLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FormModal;
